import { apiClient } from './client';
import type { Category } from '../types';

interface CategoriesResponse {
  categories: Category[];
}

interface CreateCategoryData {
  name: string;
  description: string;
  sort_order?: number;
  is_active: boolean;
}

export const adminCategoriesApi = {
  // Get all categories (including inactive)
  async getCategories(): Promise<CategoriesResponse> {
    const response = await apiClient.get<CategoriesResponse>('/admin/categories');
    return response;
  },

  // Create category
  async createCategory(data: CreateCategoryData): Promise<Category> {
    const response = await apiClient.post<Category>('/admin/categories', data);
    return response;
  },

  // Update category
  async updateCategory(id: number, data: Partial<CreateCategoryData>): Promise<Category> {
    const response = await apiClient.put<Category>(`/admin/categories/${id}`, data);
    return response;
  },

  // Delete category
  async deleteCategory(id: number): Promise<void> {
    await apiClient.delete(`/admin/categories/${id}`);
  },

  // Reorder category
  async reorderCategory(id: number, direction: 'up' | 'down'): Promise<Category> {
    const response = await apiClient.patch<Category>(`/admin/categories/${id}/reorder`, { direction });
    return response;
  },
};
